/**
 * Email link indicator
 * Decorative mail icon shown before a CTA label in the canvas when the CTA links to an event email.
 */

import type React from "react";
import { Mail } from "lucide-react";
import { isEmailLink } from "../../../../_logic/smart-link-utils";

interface EmailLinkIndicatorProps {
  /** The CTA's link */
  href: string | null | undefined;
}

/**
 * Renders a mail icon when the CTA links to an event email.
 * @param props - The CTA's link
 * @returns The icon for an email link, otherwise null
 */
export function EmailLinkIndicator({ href }: EmailLinkIndicatorProps): React.ReactElement | null {
  if (!isEmailLink(href)) return null;
  return <Mail className="h-4 w-4 shrink-0" aria-hidden="true" />;
}
